import Api from './index';
import { formatData } from 'util/formdata-util';

const routePrefix = 'users/me/assignments';

const createAssignment = (assignments: any) => Api.post(routePrefix, { data: assignments });

const saveAssignment = (assignmentId: number, options: any) =>
  Api.put(`${routePrefix}/${assignmentId}`, options);

const createAssignmentInstructions = (assignmentId, file) => {
  const formData = formatData('instructions', file);
  return Api.post(`${routePrefix}/${assignmentId}/instructions`, { data: formData });
};

const deleteUserAssignmentInstructions = assignmentId =>
  Api.destroy(`${routePrefix}/${assignmentId}/instructions`);

const fetchUserAssignmentsView = (productCurriculumId, params?) =>
  Api.get(`users/me/assignments-view`, { params: { productCurriculumId, ...params } });

const getUserAssignments = (productCurriculumId: number, params?: any) =>
  Api.get(routePrefix, { params: { productCurriculumId, ...params } });

const getUserAssignment = (assignmentId: number, params?: any) =>
  Api.get(`${routePrefix}/${assignmentId}`, { params });

const deleteUserAssignment = (assignmentId: number, params?: any) =>
  Api.destroy(`${routePrefix}/${assignmentId}`, { params });

const deleteUserAssignments = (params?: any) => Api.destroy(routePrefix, { params });

const getAssignmentAttempt = (assignmentId: number, studentId: number) =>
  Api.get(`${routePrefix}/${assignmentId}/students/${studentId}`);

const createMessage = (assignmentId: number, studentId: number, message: any) =>
  Api.post(`${routePrefix}/${assignmentId}/students/${studentId}/messages`, {
    data: message
  });

const createAudioMessage = (
  assignmentId: number,
  studentId: number,
  file: any,
  attemptId?: number
) => {
  const additionalFields = attemptId ? [{ key: 'attemptId', value: `${attemptId}` }] : [];
  const formData = formatData('message', file, additionalFields);
  return Api.post(`${routePrefix}/${assignmentId}/students/${studentId}/messages`, {
    data: formData
  });
};

const updateMessages = (assignmentId: number, studentId: number, params: any, updates: any) =>
  Api.put(`${routePrefix}/${assignmentId}/students/${studentId}/messages`, {
    params,
    data: updates
  });

export {
  getUserAssignments,
  getUserAssignment,
  createAssignment,
  saveAssignment,
  deleteUserAssignment,
  deleteUserAssignments,
  createAssignmentInstructions,
  fetchUserAssignmentsView,
  getAssignmentAttempt,
  createMessage,
  createAudioMessage,
  updateMessages,
  deleteUserAssignmentInstructions
};
